export enum AccountType {
  UNSET_ACCOUNT_TYPE = 'UNSET_ACCOUNT_TYPE',
  CONSUMER = 'CONSUMER',
  OXIO_ADMIN = 'OXIO_ADMIN',
  BRAND_REP = 'BRAND_REP',
  PAYMENT_CHANNEL_REP = 'PAYMENT_CHANNEL_REP',
  DISTRIBUTOR_REP = 'DISTRIBUTOR_REP',
}
